class r extends Error{constructor(r,s,t){super(r),this.code=s,this.data=t}}export{r as EmbeddedProviderError};
